import { Controller } from "@hotwired/stimulus"

// Character counter for text fields
// Usage:
//   <div data-controller="char-counter">
//     <textarea data-char-counter-target="input" data-action="input->char-counter#update"></textarea>
//     <span data-char-counter-target="count">0</span>/160 characters
//   </div>
//
export default class extends Controller {
  static targets = ["input", "count"]

  connect() {
    this.update()
  }

  update() {
    if (this.hasInputTarget && this.hasCountTarget) {
      this.countTarget.textContent = this.inputTarget.value.length
    }
  }
}
